import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/use-auth.js";

export default function ProtectedRoute({ isAdmin = false, children }) {
  const auth = useAuth();
  if (!auth.user || (isAdmin && !auth.user.isAdmin)) {
    return <Navigate to="/"/>;
  }
  return children ? children : <Outlet/>;
}
  